export const CERTIFICATIONS_ICE_MACHINE_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/path-to-logo.png"
   },
   "sameAs": [
    "https://www.instagram.com/everestoficial_",
    "https://www.facebook.com/everestoficialbr"
   ]
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Sua escolha em Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/#organization"
   },
   "inLanguage": "pt-BR"
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/certificacoes-maquinas-de-gelo#webpage",
   "url": "https://everest.ind.br/pt/certificacoes-maquinas-de-gelo",
   "name": "Certificações das Máquinas de Gelo Everest | Normas e Selos",
   "description": "A Everest é a marca referência em máquinas de gelo no Brasil, cumprindo as determinações e recebendo as principais certificações para trazer segurança no consumo.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/#website"
   },
   "about": {
    "@id": "https://everest.ind.br/#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/certificacoes-maquinas-de-gelo#breadcrumb"
   },
   "mainEntity": {
    "@id": "https://everest.ind.br/pt/certificacoes-maquinas-de-gelo#certifications"
   },
   "dateModified": "2026-04-16"
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/certificacoes-maquinas-de-gelo#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Certificações",
     "item": "https://everest.ind.br/pt/certificacoes-maquinas-de-gelo"
    }
   ]
  },
  {
   "@type": "DefinedTermSet",
   "@id": "https://everest.ind.br/pt/certificacoes-maquinas-de-gelo#certifications",
   "name": "Certificações das Máquinas de Gelo Everest",
   "hasDefinedTerm": [
    {
     "@type": "DefinedTerm",
     "name": "IFBQ Bauer",
     "description": "Certificação que garante conformidade com padrões de qualidade e segurança no Brasil."
    }
   ]
  }
 ]
}
